import React, { createContext, useContext } from 'react';

/**
 * Embedded: a settings section shown inside another page (a Getting started
 * step) instead of on its own route. Sections stay as they are; the kit
 * pieces they're built from read this and adapt:
 *
 * - `SectionBody` drops the page gutter, top padding and full height.
 * - `SectionHead` keeps its description and action but not its title, which
 *   the host already shows.
 * - `SaveBar` sits under the form as a rounded bar instead of sticking to
 *   the bottom of the page.
 *
 * Sections with page-only furniture (a back link, a bleed to the page
 * edge) read `useEmbedded()` themselves.
 */
const EmbeddedContext = createContext(false);

export const Embedded: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <EmbeddedContext.Provider value={true}>{children}</EmbeddedContext.Provider>
);

export const useEmbedded = () => useContext(EmbeddedContext);
